import "twin.macro";
import { ServiceData } from "../../data/ServiceData";
import wave from "../../icons/Wave.svg";
import ServiceCard from "../Card/ServiceCard";
import Title from "../Title";
import React from "react";

const ServicesSection = () => {
  return (
    <div
      style={{ backgroundImage: `url(${wave})` }}
      tw="flex flex-col  py-20 md:py-0 min-h-screen bg-gray-700 text-white! justify-center items-center  space-y-10  bg-no-repeat bg-cover bg-center"
    >
      <Title title="Our Services" />

      <div tw="grid md:grid-cols-2  max-w-3xl mx-auto justify-center items-center gap-5 p-4">
        {ServiceData.map((card, index) => (
          <ServiceCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default ServicesSection;
